import BaseDocumentHead, { IDocumentHead } from 'components/DocumentHead'
import { getHreflangByI18nKey } from 'components/DocumentHead/helpers'
import TrackContentPageView from 'helpers/tracking/trackerComponents/TrackContentPageView'
import { inject } from 'mobx-react'
import * as R from 'ramda'
import React, { FC } from 'react'
import { IStoreProvider } from 'store'

const DocumentHead: FC<Partial<IDocumentHead>> = props => {
  return (
    <>
      <TrackContentPageView pageTitle={props.title || ''} />
      <BaseDocumentHead {...props} />
    </>
  )
}

export default R.compose(
  inject((store: IStoreProvider) => {
    const { originByLocaleMap, translatedUrlsPerLocale } = store.urlManagerStore

    const links = getHreflangByI18nKey({
      key: 'dein-shop_url',
      originByLocaleMap,
      translatedUrlsPerLocale,
      excludeLocales: store.featureStore.getDisabledExpansionLocales(),
    })
    return {
      renderHreflangs: true,
      links,
      renderCanonical: false,
    }
  }),
)(DocumentHead)
